import React from 'react';
import { LOGO_URL } from '../lib/constants';

const BackgroundLayer = () => {
  return (
    <>
      {/* Fixed centered, slightly blurred Kempo Patch */}
      <div
        aria-hidden="true"
        className="fixed inset-0 -z-20 pointer-events-none flex items-center justify-center"
        data-testid="bg-patch-layer"
      >
        <img
          src={LOGO_URL}
          alt=""
          className="w-[min(94vw,1000px)] max-w-none patch-breathe"
          style={{
            opacity: 0.26,
            filter: 'blur(1.2px) saturate(1.05) contrast(1.05)',
            transform: 'translateZ(0)',
          }}
        />
      </div>

      {/* Readability gradient overlay */}
      <div
        aria-hidden="true"
        className="fixed inset-0 -z-10 pointer-events-none"
        data-testid="bg-overlay-layer"
      >
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(1100px circle at 50% 18%, rgba(255,42,42,0.10), transparent 55%), linear-gradient(to bottom, rgba(7,8,10,0.42), rgba(7,8,10,0.78))',
          }}
        />
        {/* Subtle grid */}
        <div className="absolute inset-0 grid-overlay opacity-[0.05]" />
        {/* Scanlines */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px)',
            backgroundSize: '100% 5px',
            mixBlendMode: 'overlay',
            opacity: 0.4,
          }}
        />
        {/* Vignette */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(closest-side, transparent 60%, rgba(0,0,0,0.5) 100%)',
          }}
        />
      </div>
    </>
  );
};

export default BackgroundLayer;
